import httpClient from './httpClient';

export default {
  getData: id => httpClient.get(`/feedback/user/get/${id}`),
  submitFeedback: (id, payload) => httpClient.post(`/feedback/submit/${id}`, payload),
};
